import { COMMON_FILTER_FIELD_IDS } from '../../reports-components/shared-filter-fields/reports-filter-field-ids';

// Pure constants module — kept separate from `use-recurring-revenue-filter-fields`
// so worker code can consume the IDs without pulling React-using filter-field
// builders into the worker bundle.

export const SUBSIDIARY_FIELD_ID = 'subsidiaryName';
export const RECURRING_REVENUE_CURRENCY_FIELD_ID = 'originalCurrency';

export const RECURRING_REVENUE_FILTER_FIELD_IDS = Object.freeze({
  CustomerId: COMMON_FILTER_FIELD_IDS.Customer,
  Subsidiary: SUBSIDIARY_FIELD_ID,
  Country: COMMON_FILTER_FIELD_IDS.Country,
  State: COMMON_FILTER_FIELD_IDS.State,
  Product: COMMON_FILTER_FIELD_IDS.Product,
  ContractStatus: COMMON_FILTER_FIELD_IDS.ContractStatus,
  Currency: RECURRING_REVENUE_CURRENCY_FIELD_ID,
  Label: COMMON_FILTER_FIELD_IDS.Labels,
  Plan: COMMON_FILTER_FIELD_IDS.Plan,
  ContractStartDate: COMMON_FILTER_FIELD_IDS.ContractStartDate,
});
